var _style, _polygon, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAghux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 555.83 291.11",
    style: {
      enableBackground: "new 0 0 555.83 291.11"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#9D9D9C;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{fill:#B2292E;}\r\n\t.st4{fill:#98C02B;}\r\n\t.st5{fill:#9C9E9E;}\r\n\t.st6{fill:url(#SVGID_00000173848082227599073480000001765982633975148956_);}\r\n\t.st7{fill:url(#SVGID_00000127730766396993898590000016611010628661596304_);}\r\n\t.st8{fill:url(#SVGID_00000034084855922070515490000006265250532274468253_);}\r\n\t.st9{fill:url(#SVGID_00000136374098493806575710000006927254479534585015_);}\r\n\t.st10{fill:url(#SVGID_00000045583978471581073370000012429921965042500248_);}\r\n\t.st11{fill:url(#SVGID_00000038391962447865635760000001950007913517060505_);}\r\n\t.st12{fill:url(#SVGID_00000116231095947770416960000010218741760540761239_);}\r\n\t.st13{fill:url(#SVGID_00000103255641098069592530000003142510891278971020_);}\r\n\t.st14{fill:url(#SVGID_00000124160805355396136340000018126311176422154416_);}\r\n\t.st15{fill:url(#SVGID_00000118398668638723327320000002526668646518988465_);}\r\n\t.st16{fill:#939699;}\r\n\t.st17{fill:#ACC037;}\r\n\t.st18{display:none;}\r\n\t.st19{display:inline;fill:#98C02B;}\r\n\t.st20{display:inline;}\r\n\t.st21{fill:url(#SVGID_00000033353753884221535450000000875006166400253346_);}\r\n\t.st22{fill:url(#SVGID_00000083078451610246248250000017086870575157965478_);}\r\n\t.st23{fill:url(#SVGID_00000058560716909848587710000006446249787229563801_);}\r\n\t.st24{fill:url(#SVGID_00000002362006222985100930000016029725697412701112_);}\r\n\t.st25{fill:url(#SVGID_00000153700239431275001980000011930006906336513408_);}\r\n\t.st26{fill:url(#SVGID_00000114049518765040671780000003227720296271994769_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "553.75,130.4 524.68,130.41 506.96,160 489.25,130.41 460.5,130.41 492.44,184.4 446.13,262.21  474.9,262.21 506.78,208.84 524.73,239.43 553.8,239.43 521.37,184.43  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M123.59,287.53H96.8l-15.97-48.11H36.68l-7.2,22.78H2.68l42.12-120.72c1.85-4.2,3.91-7.1,6.19-8.7 c2.28-1.6,5.08-2.41,8.41-2.41s6,0.74,8.04,2.22c2.03,1.48,3.85,4.45,5.45,8.89L123.59,287.53z M74.92,217.76L59.4,165.55 l-16.26,52.21H74.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M115.74,200.17v-16.29c0-17.16,4.49-30.55,13.49-40.18c8.99-9.63,21.43-14.44,37.32-14.44 c15.89,0,28.63,4.81,38.24,14.44c6.77,6.79,10.16,16.98,10.16,30.55h-24.02c0-14.69-7.82-22.03-23.46-22.03 c-4.68,0-8.66,0.89-11.92,2.68c-3.27,1.79-5.7,3.86-7.3,6.2c-1.6,2.35-2.83,5.8-3.69,10.37c-0.86,4.57-1.36,8.4-1.48,11.48 c-0.12,3.09-0.18,7.22-0.18,12.41c0,5.18,0.03,8.67,0.09,10.46c0.06,1.79,0.25,4.69,0.55,8.7c0.31,4.01,0.8,6.88,1.48,8.61 c0.67,1.73,1.66,3.95,2.96,6.67c1.29,2.72,2.92,4.63,4.9,5.74c5.05,3.21,10.77,4.81,17.18,4.81c10.72,0,18.29-4.56,22.72-13.7 v-8.89h-15.89v-21.48h37.87v39.81c-3.82,9.01-9.86,15.8-18.1,20.37c-8.25,4.57-17.61,6.85-28.08,6.85 c-18.6,0-32.05-5.21-40.36-15.64C119.9,237.24,115.74,221.41,115.74,200.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M330.03,262.2h-25.68v-53.32h-48.22v53.32h-25.68V130.37h25.68v55.73h48.22l-0.05-81.02h25.68L330.03,262.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M446.23,130.37v86.65c0,14.32-4.84,25.61-14.5,33.88c-9.67,8.27-21.59,12.41-35.75,12.41 c-14.16,0-26.08-4.13-35.75-12.41c-9.67-8.27-14.5-19.56-14.5-33.88v-86.65h25.68v85.72c0,8.15,2.24,14.23,6.74,18.24 c4.49,4.01,10.44,6.02,17.83,6.02s13.36-2,17.92-6.02c4.55-4.01,6.83-10.09,6.83-18.24v-85.72H446.23z"
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M471.45,43.01L398.4,3.17c-1.65-0.9-3.64-0.9-5.29,0l-73.05,39.84c-1.42,0.77-1.42,2.81,0,3.59l73.05,39.84 c1.65,0.9,3.64,0.9,5.29,0l73.05-39.84C472.87,45.83,472.87,43.79,471.45,43.01z M411.21,61.63l-15.91-8.7l-15.86,8.73 l-15.31-8.43l15.84-8.68l-15.95-8.72l15.3-8.39l15.98,8.74l15.94-8.72l15.26,8.41l-15.88,8.68l15.98,8.67L411.21,61.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.76,
    y1: 104.4616,
    x2: 395.76,
    y2: 40.5783
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C9E9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#585857"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M398.71,92.25c-1.84,1-4.06,1-5.9,0l-47.31-25.8v5.65v16.46v12.37c0,1.7,0.93,3.27,2.43,4.08l45.62,24.76 c1.38,0.75,3.05,0.75,4.43,0L443.59,105c1.5-0.81,2.43-2.38,2.43-4.08V88.55V72.09v-5.65L398.71,92.25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059278762652524931220000012405183841907889303_",
    gradientUnits: "userSpaceOnUse",
    x1: 467.5604,
    y1: 97.4863,
    x2: 467.5604,
    y2: 23.3879
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9C9E9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#585857"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059278762652524931220000012405183841907889303_)"
    },
    d: "M474.74,50.78l-11.87,6.48 c-1.53,0.84-2.49,2.44-2.49,4.19v63.43h14.36L474.74,50.78L474.74,50.78z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAghux);
export default __webpack_public_path__ + "static/media/logoAghux.0015ed6cb86e6cf695280e84e0d1e261.svg";
export { ForwardRef as ReactComponent };